import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import Drawer from "@material-ui/core/Drawer/index";
import Divider from "@material-ui/core/Divider/index";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card/index";
import CardHeader from "@material-ui/core/CardHeader/index";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Alert } from "react-bootstrap";
import { BsPersonLinesFill } from "react-icons/bs";

const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#231B88",
  },
});

export default function View(props) {
  const { open, onClose, onDutyChoose, chooseDutyId } = props;
  const [duty, setDuty] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { name } = duty;

  useEffect(() => {
    setIsLoading(true);
    onDutyChoose(chooseDutyId)
      .then((res) => {
        setDuty(res.data);
        setIsLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [chooseDutyId, onDutyChoose]);

  const classes = useStyles();


  const sideList = (side) => (
    <div className={classes.list} role="presentation">
      <div className="col-12 d-flex align-items-center justify-content-between py-4">
        <h1 className="h3 mb-0">Vəzifə detalları</h1>
        <CloseIcon className={classes.pointer} onClick={onClose} />
      </div>
      <Divider className="bg-dark" />

      {isLoading ? (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      ) : !isLoading && !isError ? (
        <div className="drawer-body">
          <Card className={classes.card}>
            <CardHeader
              title="Ümumi informasiya"
              className="bg-secondary text-dark h6 p-3"
              disableTypography
            />
            <CardHeader
              avatar={
             
                <BsPersonLinesFill className="icon-primary"/>
              }
              title={name}
              subheader="Ad"
              className="p-3"
            />
         
          </Card>
        </div>
      ) : (
        <div className="p-5">
          <Alert variant="info">Xəta baş verdi.</Alert>
        </div>
      )}
    </div>
  );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
      className="drawer--fixed"
    >
      {sideList("right")}
    </Drawer>
  );
}
